import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Span from '@deliveroo/consumer-component-library/components/Span';
import styles from './styles.scss';

/**
 * Used to show a single filter option.
 */
const FilterButton = ({ children, isSelected, onClick }) => {
  const buttonClasses = classnames({
    [styles.selected]: isSelected,
    [styles.button]: true,
  });
  return (
    <Spacer element="span">
      <button type="button" onClick={onClick} className={buttonClasses}>
        <Span size="small">{children}</Span>
      </button>
    </Spacer>
  );
};

FilterButton.propTypes = {
  /**
   * The text of the filter item
   */
  children: PropTypes.node.isRequired,
  /**
   * Whether the filter item is selected
   */
  isSelected: PropTypes.bool,
  /**
   * A function to handle onClick for the button
   */
  onClick: PropTypes.func.isRequired,
};

FilterButton.defaultProps = {
  isSelected: false,
};

export default FilterButton;
